import { render, staticRenderFns } from "./JobNewView.vue?vue&type=template&id=480a0689&"
import script from "./JobNewView.vue?vue&type=script&setup=true&lang=js&"
export * from "./JobNewView.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports